/* global axios */
import ApiClient from './ApiClient';

class SocialResponseTemplatesAPI extends ApiClient {
  constructor() {
    super('social_response_templates', { accountScoped: true });
  }

  // Era this.axios (que o ApiClient não tem): a busca por caixa quebrava, o
  // store engolia o erro e a tela de automações nunca mostrava modelo nenhum.
  getByInbox(inboxId) {
    return axios.get(this.url, { params: { inbox_id: inboxId } });
  }
}

export default new SocialResponseTemplatesAPI();
